import keyMirror from "keymirror";

export default keyMirror({
    ACCEPTED: null,
    PENDING: null,
    REJECTED: null,
    TERMINAL: null,
    OPEN_EXPIRED: null,
});
